var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4574 13.2287L29.2065 14.1667H3.78369L0.416687 8.33333H25.7007C28.258 8.33333 30.1189 10.7588 29.4574 13.2287ZM31.1012 8.33333L32.9375 11.5125L29.882 22.9167H35.9207L39.8279 8.33333H31.1024H31.1012ZM28.4249 17.0833H12.2969C11.1232 17.0833 10.0965 17.872 9.79202 19.0048L6.40052 31.6667H12.438L14.5252 23.878C14.6769 23.311 15.1902 22.9167 15.777 22.9167H20.8229L18.4779 31.6667H33.5745L35.1379 25.8333H26.0787L28.4237 17.0833H28.4249Z",
    fill: "#FB4C0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6613 14.7978H50.839V28.8667H55.0005V14.7978H60.1781V11.3702H45.6613V14.7978Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6819 11.1333C64.93 11.1333 61.7614 13.9473 61.7614 18.1788V28.8667H65.9217V24.1848H73.4175V28.8667H77.5802V18.1788C77.5802 13.9462 74.4115 11.1333 69.6819 11.1333ZM73.4175 20.7572H65.9217V18.3445C65.9217 16.0753 67.4115 14.5622 69.7052 14.5622C71.9989 14.5622 73.4175 16.0742 73.4175 18.3445V20.7572Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0142 11.3702H80.8527V28.8667H92.4377V25.4378H85.0142V11.3702Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8878 11.3702H95.7263V28.8667H99.8878V11.3702Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLarge);
export default __webpack_public_path__ + "static/media/logo-large.71d9e1937f0333f3740d488d7639e7e8.svg";
export { ForwardRef as ReactComponent };